import request, { HttpMethod } from '@app/libs/request';
import { serverUrl } from '@app/config';
import { Organization, OrganizationServerResponse, StoreOrganizationRequest } from '@app/domain/userManagement/organizations';

export type OrganizationsSortCriteria = 'Name' | 'ServiceCount';
export type OrganizationsSortOrder = 'ASC' | 'DESC';

export interface SearchOrganizationsRequest {
  query?: string;
  serviceIds?: string[];
  sort: OrganizationsSortCriteria;
  order: OrganizationsSortOrder;
  offset: number;
  limit: number;
}

export async function searchOrganizations(
  params: SearchOrganizationsRequest,
  abortSignal: AbortSignal,
): Promise<PaginatedData<OrganizationServerResponse>> {
  return request<PaginatedData<OrganizationServerResponse>>(serverUrl, `/api/organizations/search`, {
    method: HttpMethod.get,
    params,
    signal: abortSignal,
    errorsHandler: {
      default: {
        message: 'Cannot get organizations.',
      },
    },
  });
}

// Organizations that couldn't be loaded and are therefore missing from the search results
export async function getUnassembledOrganizationIds(): Promise<string[]> {
  return request<string[]>(serverUrl, `/api/organizations/unassembled-ids`, {
    method: HttpMethod.get,
    errorsHandler: {
      default: {
        message: 'Cannot get the organizations that could not be loaded.',
      },
    },
  });
}

export async function getOrganizationById(id: string): Promise<OrganizationServerResponse> {
  return request<OrganizationServerResponse>(serverUrl, `/api/organizations/${encodeURIComponent(id)}`, {
    method: HttpMethod.get,
    errorsHandler: {
      default: {
        message: 'Cannot get organization by id.',
      },
    },
  });
}

export default {
  async storeOrganization(data: StoreOrganizationRequest): Promise<OrganizationServerResponse> {
    return request<OrganizationServerResponse>(serverUrl, `/api/organizations`, {
      data,
      method: HttpMethod.post,
      errorsHandler: {
        default: {
          message: 'Cannot store organization.',
        },
      },
    });
  },
};

export function transformToOrganization(serverResponse: OrganizationServerResponse): Organization {
  return {
    ...serverResponse,
  };
}
